import { useEffect } from 'react'

import { Button, Icon, colors as zetColors } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import { B5, BTN } from '@zet/design-system/typography'

import DocumentHandelling from '../../../loans/customerIdentity/documentHandelling'
import { useDocumentPicker } from '../../../loans/customerIdentity/useDocumentPicker'

interface Props {
  value: any
  errorMessage?: string
  fieldId?: string
}

const UploadDocument = ({ value, errorMessage, fieldId, onChange }: Props) => {
  const {
    pickDocument,
    documentName,
    setDocumentName,
    selectedDocument,
    isUploading,
  } = useDocumentPicker(fieldId)

  useEffect(() => {
    if (documentName && !isUploading) {
      onChange(documentName)
    }
  }, [documentName, isUploading])

  return (
    <Stack>
      {selectedDocument ? (
        <DocumentHandelling
          document={documentName ? documentName : 'document name.pdf'}
        />
      ) : (
        <></>
      )}
      <Button
        fullWidth
        intent="primary-outline"
        className="mb-2 mt-1"
        onPress={() => pickDocument(fieldId)}
      >
        <XStack className="items-center space-x-1">
          <Icon
            type="DocumentOutlined"
            size={16}
            color={zetColors.primary[100]}
          />
          <BTN className="text-primary-100">
            {value || documentName ? 'Re-upload file' : 'Upload'}
          </BTN>
        </XStack>
      </Button>
      {!!errorMessage && <B5 className="text-error-100">{errorMessage}</B5>}
    </Stack>
  )
}

export default UploadDocument
